// let protocol = location.protocol === 'https:' ? 'wss' : 'ws';
export default {
  baseUrl: {
    // dev: "http://localhost:3000/",
    dev: "https://www.aidprint.com/",
    pro: "https://www.aidprint.com/"
  },
  // ws:"ws://192.168.0.146:4001",
  ws: "wss://socket.aidprint.com",
  payQrcodeUrl: "https://www.aidprint.com/wx/RechargePay/pay",
  WechatOpen: {
    AppId: "wx1f68b6a27a8e2814",
  },
  Dingtalk:{
    AppId: "dingoajcfoilhoez0ru1jz",
  }
};
